import { FC, memo, ReactNode, useEffect, useMemo, useRef } from 'react';
import { FormikProvider, useFormik } from 'formik';
import { PlaygroundHeader } from 'modules/Playground/Components/PlaygroundHeader';
import { RenderPlaygroundContent } from 'modules/Playground/Components/RenderPlaygroundContent';
import { PanelProvider, PanelId } from './PanelContext';
import { styles } from './PanelManager.styled';
import { PlaygroundConfig } from '../types/playgroundConfig';
import { useGetModelByQueryParam } from '../hooks/utils/useGetModelByQueryParam';
interface PanelProps {
  panelId: PanelId;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onCompareModeToggle?: () => void;
  children?: ReactNode;
  initialValue: PlaygroundConfig;
  asyncInitialization?: boolean;
}
export const Panel: FC<PanelProps> = memo(({
  panelId,
  initialValue,
  onCompareModeToggle,
  asyncInitialization
}) => {
  const modelInitializedRef = useRef(false);
  const createPanelInitialValues = (baseValues: PlaygroundConfig): PlaygroundConfig => ({
    ...baseValues,
    fieldValueMap: {
      ...baseValues.fieldValueMap
    },
    isOutputLoading: false
  });
  const {
    model
  } = useGetModelByQueryParam(panelId);
  const initialState = useMemo(() => {
    const baseValues = createPanelInitialValues(initialValue);
    return {
      ...baseValues,
      model: model || baseValues.model,
      modelVersion: model?.model_version || baseValues.modelVersion
    };
  }, [initialValue, model, createPanelInitialValues]);
  const formikState = useFormik({
    initialValues: initialState,
    onSubmit: () => {},
    enableReinitialize: false
  });
  useEffect(() => {
    if (model?.id && !modelInitializedRef.current && asyncInitialization) {
      formikState.setValues({
        ...formikState.values,
        ...initialState
      });
      modelInitializedRef.current = true;
    }
  }, [model, initialState, formikState, asyncInitialization]);
  return <div className={styles.comparePanel} data-panel={panelId} key={`${panelId}-panel`}>
      <FormikProvider value={formikState}>
        <PanelProvider panelId={panelId}>
          <div className={styles.comparePanelContent}>
            <PlaygroundHeader onCompareModeToggle={onCompareModeToggle} />
            <RenderPlaygroundContent />
          </div>
        </PanelProvider>
      </FormikProvider>
    </div>;
});